import React from 'react'
import injectSheet from 'react-jss'
import {
  ContentContainer,
  InfoContainer,
  TextButton,
} from '../../'

const BudgetError = (props) => {
  const {
    budgetError,
    classes,
    history,
    setBudgetIgnore,
  } = props

  const handleAdjust = () => history.push('/budget')
  const handleIgnore = () => {
    setBudgetIgnore(true)
    history.goBack()
  }

  return (
    <ContentContainer small>
      <InfoContainer warning>
        <h2>{budgetError.title}</h2>
        <h4>{budgetError.subTitle}</h4>
        <p>{budgetError.description}</p>
        <div className={`${classes.buttonContainer}`}>
          <TextButton
            handleClick={() => handleAdjust()}
            index={0}
            text={budgetError.adjust}
            primary
          />
          <TextButton
            handleClick={() => handleIgnore()}
            index={1}
            text={budgetError.ignore}
          />
        </div>
      </InfoContainer>
    </ContentContainer>
  )
}

const styles = () => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
})


export default injectSheet(styles)(BudgetError)



// WEBPACK FOOTER //
// ./src/modules/budget/components/budgetError.jsx